import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';

@Injectable({
	providedIn: 'root'
})
export class DownloadFileService {

	constructor(
		private apiService: ApiService,
		private toastController: ToastController
	) { }

	async download(url: string, fileName: string): Promise<Observable<Blob>> {
		const startDownloadToast = await this.toastStartDownload(fileName);
		const downloadRequest$ = this.apiService.get<Blob>(url, { responseType: 'blob' });

		downloadRequest$.subscribe(
			async (blob) => {
				await startDownloadToast.dismiss();
				saveAs(blob, fileName, {
					type: blob.type
				});
			},
			async _ => {
				await startDownloadToast.dismiss();
			}
		);

		return downloadRequest$;
	}

	async toastStartDownload(fileName: string): Promise<HTMLIonToastElement> {
		const downloadToast = await this.toastController.create({
			message: `Downloading "${fileName}"...`,
			position: 'bottom',
		});

		await downloadToast.present();
		return downloadToast;
	}
}
